/*
 * @Description: 
 * @Author: 杨志航<yangzhihang@372163.com>
 * @Date: 2022-01-08 16:29:36
 */

export const regExt = {
  phone: /^1[3456789]\d{9}$/,
  mail: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{1,30})$/,
  identity: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  bankNo: /^([1-9]{1})(\d{15}|\d{16}|\d{18})$/,
  password: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])^[0-9A-Za-z\S]{7,30}$/,
  passwordModify: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])^[0-9A-Za-z\S]{7,20}$/,
}

export const cryptoIndex = 'ad629fddf8b8756d2e72e96ae035a5a4'

// 待办事项
export const scheduleObj = {
  44: '/performance/adjustment/detail',
  10: '/hr/promotion/detail',
  18: '/office/procedure/officeworkdetail',
  19: '/hr/jobTransfer/detail',
  9: '/hr/recruit/detail',
  12: '/protocol/invoice/detail',
  13: '/hr/dimission/detail',
  8: '/attendance/appeal/details',
  15: '/attendance/askforleave/addaskdetail',
  20: '/setSystem/helpCenterMgt/replydetail',
  31: '/csr/vendorIdAudit/detail',
  38: '/orderDirect/directDetail',
  39: '/orderAgent/agentDetail',
  28: '/csr/addAudit/detail',
  29: '/csr/nameChangeAudit/detail',
  33: '/protocol/replenish/details',
  34: '/protocol/contract/details',
  35: '/protocol/quittance/details',
  30: '/account/creditapply/details',
  23: '/fund/refundManage/details',
  17: '/fund/moneyTransmit/details', // 转款
  22: '/fund/moneyClaim/detail', // 认款
  24: '/agent/agentNew/agentNewDetail', // 代理商新增
  244: '/agent/nameManage/details', // 代理商变更
  26: '/agent/manufacturer/details',
  32: '/csr/turnAudit/detail',
  25: '/agent/integralManage/details',
  36: '/protocol/invoice/detail', // 发票清理
  37: '/protocol/invoice/detail', // 发票冲红
  27: '/agent/agentTransfer/detail',
  40: '/orderDirect/refundDetail', //直销退单
  41: '/orderAgent/refundDetail', //代理商退单
  42: '/orderDirect/paybackDetail', //直销负利还款
  43: '/orderAgent/paybackDetail', //直销负利还款
  45: '/protocol/replenish', //补充协议管理执行
  46: '/supplie/topUp/detail', //系统充值
  47: '/office/costManagement/details', //费用审批
  48: '/asset/purchase/details', // 采购
  49: '/attendance/askforleave/addaskdetails', //育儿假资格申请
  51: '/corpAccount/InternalAccount/details', //内部往来款
  50: '/supplie/supplierContract/details', //合同内容确认
  52: '/supplie/supplierContractSeal/details', //合同盖章申请
  53: '/vr/audit', //设备借出审批
  54: '/vr/audit', //设备归还审批
  55: '/vr/stock', //设备待维修完成 
  56: '/vr/audit', //设备维修完成审批
  57: '/protocol/operationalChange/details', //合同运营属性变更
  58: '/ach/achaudit/detail', //绩效审批
  59: '/ach/probationachaudit/detail', //试用期绩效考核审批
}

// 系统消息
export const newsObj = {
  0: '/office/procedure/officeworkdetail',
  10: '/hr/promotion/detail',
  20: '/hr/jobTransfer/detail',
  26: '/hr/employee/details',
  25: '/helplist',
  27: '/importDown/tolead',
  9: '/hr/recruit/detail',
  13: '/hr/dimission/detail',
  8: '/attendance/appeal/details',
  15: '/attendance/askforleave/addaskdetail',
  5: '/attendance/individual',
  30: '/helplist/details',
  12: '/protocol/invoice/detail',
  37: '/csr/addAudit/detail',
  38: '/csr/nameChangeAudit/detail',
  40: '/csr/vendorIdAudit/detail',
  43: '/protocol/replenish/details',
  44: '/protocol/contract/details',
  45: '/protocol/quittance/details',
  48: '/orderDirect/directDetail',
  49: '/orderAgent/agentDetail',
  39: '/account/creditapply/details',
  32: '/fund/refundManage/details',
  17: '/fund/moneyTransmit/details',
  31: '/fund/moneyClaim/detail',
  33: '/agent/agentNew/agentNewDetail', // 代理商新增
  333: '/agent/nameManage/details', // 代理商变更
  35: '/agent/manufacturer/details',
  42: '/csr/turnAudit/detail',
  34: '/agent/integralManage/details',
  46: '/protocol/invoice/detail', // 发票清理
  47: '/protocol/invoice/detail', // 发票冲红
  36: '/agent/agentTransfer/detail',
  50: '/orderDirect/refundDetail', //直销退单
  51: '/orderAgent/refundDetail', //代理商退单
  52: '/orderDirect/paybackDetail', //直销负利还款
  53: '/orderAgent/paybackDetail', //直销负利还款
  57: '/supplie/topUp/detail', //系统充值
  58: '/office/costManagement/details', //费用审批
  59: '/asset/purchase/details', // 采购
  60: '/attendance/askforleave/addaskdetails', //育儿假资格申请
  62: '/corpAccount/InternalAccount/details', //公司内部往来款
  61: '/supplie/supplierContract/details', //合同内容确认
  63: '/supplie/supplierContractSeal/details', //合同盖章申请
  64: '/vr/audit', //设备借出审批
  65: '/vr/audit', //设备归还审批
  66: '/vr/stock', //设备待维修完成 
  67: '/vr/audit', //设备维修完成审批
  68: '/protocol/operationalChange/details', //合同运营属性变更
  69: '/ach/achaudit/detail', //绩效审批
  70: '/ach/probationachaudit/detail', //试用期绩效考核审批
}

// 系统消息 (补充资料)
export const newsObjNew = {
  12: '/protocol/invoice/apply', // 发票
}

export const politicOptions = [{
  name: '群众',
  id: 1,
}, {
  name: '团员',
  id: 2,
}, {
  name: '预备党员',
  id: 3,
}, {
  name: '党员',
  id: 4,
}, {
  name: '其他',
  id: 5,
}]

export const recruitmentSourceOptions = [{
  name: '拉钩',
  id: 1,
}, {
  name: '赶集',
  id: 2,
}, {
  name: '前程无忧',
  id: 3,
}, {
  name: '58同城',
  id: 4,
}, {
  name: '智联',
  id: 5,
}, {
  name: '中华英才',
  id: 6,
}, {
  name: 'BOSS直聘',
  id: 7,
}, {
  name: '猎头',
  id: 8,
}, {
  name: '其他',
  id: 9,
}, {
  name: '内部推荐',
  id: 0,
}]

export const marriageOptions = [{
  name: '未婚',
  id: 0,
}, {
  name: '已婚',
  id: 1,
}, {
  name: '离异',
  id: 2,
}]

export const educationOptions = [{
  name: '初中',
  id: 1,
}, {
  name: '中专',
  id: 2,
}, {
  name: '高中',
  id: 3,
}, {
  name: '大专',
  id: 4,
}, {
  name: '本科',
  id: 5,
}, {
  name: '硕士研究生',
  id: 6,
}, {
  name: '博士研究生',
  id: 7,
}]

export const majorOptions = [{
  name: '文史类',
  id: 1,
}, {
  name: '理工类',
  id: 2,
}]

export const residenceOptions = [{
  name: '本市农户',
  id: 0,
}, {
  name: '本市城镇',
  id: 1,
}, {
  name: '外地农户',
  id: 2,
}, {
  name: '外地城镇',
  id: 3,
}]

export const staffTypeOptions = [{
  name: '销售',
  id: 1,
}, {
  name: '客服',
  id: 2,
}, {
  name: '职能',
  id: 3,
}, {
  name: '直播',
  id: 4,
}]

export const jobTypeList = [
  { id: 1, name: '销售'},
  { id: 2, name: '运营'},
  { id: 3, name: '职能'},
  { id: 4, name: '直播'}
]

export const expYearList = [
  { id: 1, name: '无经验'},
  { id: 2, name: '1~3年'},
  { id: 3, name: '3~5年'},
  { id: 4, name: '5~10年'},
  { id: 5, name: '10年以上'},
]

export const leaveJobTypeOptions = [{
  name: '主动离职',
  id: 0,
}, {
  name: '被动离职',
  id: 1,
}]

export const wagesTimeOptions = [{
  name: '上午',
  id: 1,
}, {
  name: '下午',
  id: 2,
}]

export const workColumns = [
  {
    title: '开始时间',
    dataIndex: 'startTime',
    inputType: 'date',
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    inputType: 'date',
  },
  {
    title: '单位名称',
    dataIndex: 'company',
  },
  {
    title: '职务',
    dataIndex: 'position',
    required: false
  },
  {
    title: '证明人',
    dataIndex: 'witness',
  },
  {
    title: '联系方式',
    dataIndex: 'mobile',
    inputType: 'number',
    regExtType: 'phone'
  },
  {
    title: '离职原因',
    dataIndex: 'leavReason',
    required: false
  },
]

export const familyColumns = [
  {
    title: '姓名',
    dataIndex: 'name',
  },
  {
    title: '与本人关系',
    dataIndex: 'relationship',
  },
  {
    title: '年龄',
    dataIndex: 'age',
    inputType: 'number',
  },
  {
    title: '工作单位',
    dataIndex: 'company',
    required: false
  },
  {
    title: '职位',
    dataIndex: 'position',
    required: false

  },
  {
    title: '联系方式',
    dataIndex: 'mobile',
    inputType: 'number',
    regExtType: 'phone'
  },
]
